export enum SocialMediaName {
  LINKEDIN = 'LINKEDIN',
  WEBSITE = 'WEBSITE',
  NOT_APPLICABLE = 'NOT_APPLICABLE'
}
